module.exports = __webpack_public_path__ + "fonts/SalesforceSans-BoldItalic.41ae6b36a1f81e8c5d2aafe12c409f30.woff";